import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1)
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = {
  class: "D-Flex",
  style: {"width":"40%","flex":"auto"}
}
const _hoisted_7 = {
  class: "DialogSection",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "CookiesDialogFooter"
}
const _hoisted_11 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_NewPassword = _resolveComponent("NewPassword")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Employees_Edit': 'HR_Employees_Create'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: 'CookiesDialog_' + _ctx.DialogIndex,
          class: "CookiesDialogdBody"
        }, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.Loading.length > 0)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CookiesImageInput, { Res: 'D_Employee_Image' })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: 'Name',
                    CookiesInvalidInput: !_ctx.MEMRead('D_Employee_Name') && _ctx.MEMRead('D_Employee_Name') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_Name') && _ctx.MEMRead('D_Employee_Name') === ''),
                    Res: 'D_Employee_Name',
                    Default: ''
                  }, null, 8, ["CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: 'Phone Number',
                    CookiesInvalidInput: _ctx.PhoneValidator(_ctx.MEMRead('D_Employee_PhoneNumber')),
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_PhoneNumber') && _ctx.MEMRead('D_Employee_PhoneNumber') === ''),
                    Res: 'D_Employee_PhoneNumber',
                    Default: ''
                  }, null, 8, ["CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: 'Email',
                    CookiesInvalidInput: _ctx.EmailValidator(_ctx.MEMRead('D_Employee_Email')),
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_Email') && _ctx.MEMRead('D_Employee_Email') === ''),
                    Res: 'D_Employee_Email',
                    Default: ''
                  }, null, 8, ["CookiesInvalidInput", "ErrorData"])
                ])
              ]),
              _hoisted_8,
              _hoisted_9,
              _createVNode(_component_CookiesCheckBox, {
                Res: 'D_Employee_CanLogin',
                Name: 'Can Login',
                PreserveMemory: false
              }),
              _createElementVNode("div", {
                class: _normalizeClass([!_ctx.MEMRead('D_Employee_CanLogin') && 'Disabled', "DialogSection"])
              }, [
                _createVNode(_component_NewPassword, {
                  Editing: _ctx.DialogData.Editing,
                  Disabled: !_ctx.MEMRead('D_Employee_CanLogin'),
                  onChangePassword: _ctx.ChangePassword,
                  ErrorsVisibilty: _ctx.ErrorsVisibilty,
                  Res: 'D_Employee_Password'
                }, null, 8, ["Editing", "Disabled", "onChangePassword", "ErrorsVisibilty"])
              ], 2)
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Employees_Edit': 'HR_Employees_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Save')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}